export default __webpack_public_path__ + "static/media/Verification.4d0ddad4.svg";